import React, { useEffect, useState } from "react";

//imagenes
import * as constant from "../../global/const";

//componentes
import SpinnerComponent from "../../Components/Loader/load.component";
import EncabezadoComponent from "../../Components/Encabezado/encabezado.component";
import LoginComponent from "../../Components/Login/login.component";
import ActivateComponent from "../../Components/Activate/activate.component";
import RegistrateComponent from "../../Components/Registrate/registrate.component";
import Whatsapp from "../../Components/Whatsapp/whatsapp.component";

import auth from "../../Helpers/auth";

const NegociosPage = (props) => {
  const [load, setLoad] = useState(true);

  var sectionStyle = {
    /* backgroundImage: 'url(' + constant.URL_BASE_IMAGES + '/Web/InicioB2B/bg.jpg?' + Math.random() +  ')' */
    backgroundImage: `url(${constant.URL_BASE_IMAGES}${
      window.innerWidth > 740 ? "web" : "movil"
    }/InicioB2B/bg.jpg)`,
  };

  useEffect(() => {
    if (auth.getToken()) props.history.push("./inicio");

    setTimeout(() => {
      setLoad(false);
    }, 1500);
  }, []);

  return (
    <React.Fragment>
      {load ? (
        <SpinnerComponent />
      ) : (
        <div>
          <div className="negocios" style={sectionStyle}>
            <EncabezadoComponent
              path="/"
              desc1={"Inicio"}
              desc2="Negocios"
              negocios={true}
            />

            <div className="section">
              <LoginComponent updateLoad={setLoad} />
              {/* <ActivateComponent updateLoad={setLoad} /> */}
              {/* <RegistrateComponent updateLoad={setLoad} /> */}
            </div>
          </div>
          <Whatsapp />
        </div>
      )}
    </React.Fragment>
  );
};

export default NegociosPage;
